import './SingleValueRenderer.css';
export var chartStateHandler = '_utn1m52-3-8-0';
export var singleValueContainer = '_utn1m50-3-8-0';
export var singleValueInnerContainer = '_utn1m51-3-8-0';
export var sparklineArea = '_utn1m53-3-8-0';
export var trendArea = '_utn1m54-3-8-0';